export default function onChangePrice(e, onChange) {
  let value = e.target.value;

  const digitsOnly = value.replace(/\D+/g, "");

  if (digitsOnly === "") {
    onChange("");
    return;
  }

  const formatted = digitsOnly.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  onChange(formatted);
}
